import styled from 'styled-components';
import { media } from '../../../components/Layout/breakpoints';

export const Header = styled.header`
  display: flex;
  justify-content: center;
  position: relative;
  height: 437px;
  /* padding-top: 120px; */
  ${media.sm`
    height: 663px;
    `}
  /* ${media.md`
    height: 663px; */
    /* & > :first-child::before {
      position: absolute;
      content: '';
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 1;
      background: linear-gradient(
        90deg,
        #0A0A2C 0%,
        rgba(0, 0, 0, 0) 10%,
        rgba(0, 0, 0, 0) 90%,
        #0A0A2C 100%
      );
    }
  `} */

  /* &::after {
    position: absolute;
    content: '';

    left: 0;
    right: 0;
    bottom: 0;
    height: 10%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #0a0a2c 100%);
  } */
`;

export const ContentWrapper = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding-left: 32px;
  padding-right: 32px;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 50px;

  h1 {
    font-size: 25px;
    line-height: 110%;
    letter-spacing: 0;
    width: 195px;
    ${media.md`
      width: 539px;
      font-size: 36px;
    `}
  }

  ${media.md`
    padding-left: 100px;
    gap: 20px;
  `}

`;


export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  ${media.sm`
    flex-direction: row;
    gap: 32px;
  `}
`;
